import api from "../api";
/**
 * 检查手机号是否已经注册
 * @param {*} params
 * @param {*} url
 */
const checkPhoneUsed = params =>
  api.post({
    service: "USER_AUTH_REGIST_PHONE",
    url: "web/user/isExist",
    urlItem: "2/",
    transURL: true,
    data: params,
    loading: false,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 检查昵称是否已经被使用
 * @param {*} params
 * @param {*} url
 */
const ckeckNickNameUsed = params =>
  api.post({
    service: "USER_AUTH_USERINFORMATION",
    url: "web/user/nickName/isExist",
    urlItem: "2/",
    transURL: true,
    data: params,
    loading: false,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 检查验证码是否输入正确
 * @param {*} params
 * @param {*} url
 */
const checkVerifyCode = params =>
  api.post({
    service: "USER_AUTH_CHECK_VERIFY_CODE",
    url: "user/phoneSms/verifyPhoneValidCode",
    urlItem: "2/",
    transURL: true,
    data: params,
    loading: false,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 获取用户信息
 * @param {*} params
 */
const login = params =>
  api.post({
    service: "LOGIN_URL",
    url: "",
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 获取验证码
 * @param {*} params
 */
const apiUserPhoneSms = (params, url) =>
  api.post({
    service: "USER_AUTH_VILIDATA",
    url: url,
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 忘记密码更改密码
 * @param {*} params
 */
const apiUpdatePasswordByPhone = params =>
  api.post({
    service: "USER_AUTH_VILIDATA",
    url: "apiUpdatePasswordByPhone",
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 注册用户信息
 * @param {*} params
 */
const userRegist = (params, url) =>
  api.post({
    service: "USER_AUTH_REGIST",
    url: url,
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 刷新token
 * @param {*} params
 */
const RefreshToken = (params, url) =>
  api.post({
    service: "USER_AUTH_REFRESHTOKEN",
    url: "",
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 验证token
 * @param {*} params
 */
const VerifyToken = (params, url) =>
  api.post({
    service: "USER_AUTH_VERIFYTOKEN",
    url: url,
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
/**
 * 页面接口
 * @param {*} params
 */
const ServiceInterface = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: url,
    urlItem: "",
    transURL: false,
    data: params,
    loading: false,
    token: true
  });
export {
  login,
  userRegist,
  apiUserPhoneSms,
  RefreshToken,
  VerifyToken,
  ServiceInterface,
  checkPhoneUsed,
  checkVerifyCode,
  ckeckNickNameUsed,
  apiUpdatePasswordByPhone
};
